import axios from "axios";
import { API_BASE_URL, TICKET_API_BASE_URL } from "utils/constants/api";

const baseURL = API_BASE_URL;

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

export const ticket_api = axios.create({
  baseURL: TICKET_API_BASE_URL,
  withCredentials: true,
});

export const SEND_CONTACT_FORM = {
  method: "post",
  url: "/api/blog/v1/email/contact-us",
};

export const GET_ALL_TICKETS = {
  method: "get",
  url: "/api/ecommerce/v1/ticketing/tickets",
};

export const GET_TICKET_BY_ID = {
  method: "get",
  url: "/api/ecommerce/v1/ticketing/tickets/:ticket_id",
};

export const GET_PRICE_CALCULATION = {
  method: "post",
  url: "/api/ecommerce/v1/ticketing/tickets/calculate/:id",
};

export const GET_ALL_PAYMENT_CHANNELS = {
  method: "get",
  url: "/api/ecommerce/v1/mpaymentchannels/all",
};

export const CREATE_BOOKING = {
  method: "post",
  url: "/api/ecommerce/v1/ticketing/booking/create",
};

export const CREATE_TICKET_FEEDBACK = {
  method: "post",
  url: "/api/ecommerce/v1/ticketing/feedback/create",
};

export const GET_USER_DETAIL_BY_TOKEN_EMAIL = {
  method: "get",
  url: "/api/ecommerce/v1/ticketing/feedback/user-detail/:participant_token",
};

export const GET_ORDER_BY_ORDER_ID = {
  method: "GET",
  url: "/api/ecommerce/v1/transactions/order/id/:order_id",
};

export const GET_ALL_ARTICLES = {
  method: "get",
  url: "/api/blog/v1/articles/all/public",
};

export const GET_ARTICLE_DETAILS = {
  method: "get",
  url: "/api/blog/v1/articles/:id",
};

export const GET_CUSTOMER_DETAILS_BY_CUSTOMER_UUID = {
  method: "get",
  url: "/api/ecommerce/v1/customers/find-by-customer-uuid/:customer_uuid",
};
